import styled from 'styled-components'

import { breakpoints } from '@src/constants/breakpoints'

export const BasketCountText = styled.p`
  font-size: 11px;
  font-weight: 700;
  margin: 0px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 18px;
  left: 26px;
  border: 2px solid;
  line-height: 18px;

  @media (max-width: ${breakpoints.tablet}px) {
    bottom: 18px;
    left: 20px;
  }
`
